import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Navigation from '../components/Navigation';
import ProductGrid from '../components/ProductGrid';
import Footer from '../components/Footer';

const Shop = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    setVisible(true);
  }, []);

  return (
    <div className="min-h-screen">
      <Navigation />

      {/* Header */}
      <section 
        className={`pt-32 pb-16 px-8 bg-neutral-50 transition-all duration-1000 ${
          visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-12'
        }`}
      >
        <div className="max-w-[1400px] mx-auto text-center">
          <h1 className="text-5xl lg:text-7xl font-light mb-6 tracking-wide">
            The Collection
          </h1>
          <p className="text-gray-600 text-lg max-w-2xl mx-auto leading-relaxed">
            Explore our complete range of artisanal spreads. Each creation represents
            the pinnacle of Dutch craftsmanship and premium ingredients.
          </p>
        </div>
      </section>

      {/* Products */}
      <section className="py-16 lg:py-24 px-8 bg-white">
        <div className="max-w-[1400px] mx-auto">
          <ProductGrid />
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Shop;